export default {"src":"/_next/static/media/hdfc-bank-icon.206ff25b.svg","height":1678,"width":1679,"blurWidth":0,"blurHeight":0};